"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverlessBaseURL = exports.GROUPS_APP_DEFINITION_ID = exports.RichContentMigration = void 0;
exports.RichContentMigration = {
    CustomTab: 'specs.groups.CustomTabContentType',
    GroupDescription: 'specs.groups.GroupDescriptionContentType',
    GroupFeed: 'specs.groups.GroupFeedContentType',
    CentralFeed: 'specs.groups.CentralFeedContentType',
};
exports.GROUPS_APP_DEFINITION_ID = '148c2287-c669-d849-d153-463c7486a694';
exports.serverlessBaseURL = '_api/social-groups-serverless';
//# sourceMappingURL=constants.js.map